import account from './endpoints/account';
import profile from './endpoints/profile';
import invitations from './endpoints/invitations';
import goals from './endpoints/goals';
import keyResults from './endpoints/keyResults';
import cycles from './endpoints/cycles';
import users from './endpoints/users';
import teams from './endpoints/teams';
import labels from './endpoints/labels';
import customGoalFilters from './endpoints/customGoalFilters';
import checkIns from './endpoints/checkIns';
import teamMemberReports from './endpoints/teamMemberReports';
import search from './endpoints/search';
import settings from './endpoints/settings';
import metrics from './endpoints/metrics';
import jira from './endpoints/jira';
import recommendedActions from './endpoints/recommendedActions';
import overTimeCharts from './endpoints/overTimeCharts';
import kpis from './endpoints/kpis';
import initiatives from './endpoints/initiatives';
import currencies from './endpoints/currencies';
import goalTemplates from './endpoints/goalTemplates';
import conversations from './endpoints/conversations';
import uploads from './endpoints/uploads';
import planner from './endpoints/planner';
import businessUnits from './endpoints/businessUnits';
import notes from './endpoints/notes';
import comments from './endpoints/comments';
import qualityChecker from './endpoints/qualityChecker';
import strategicElements from './endpoints/strategicElements';
import entityLinks from './endpoints/entityLinks';
import powerBi from './endpoints/datasources/powerBi';
import excel from './endpoints/datasources/excel';
import mcp from './endpoints/settings/mcp';
import companionContexts from './endpoints/settings/companionContexts';
import conversationStarters from './endpoints/settings/conversationStarters';
import nudgeSettings from './endpoints/settings/nudgeSettings';
import webhookSubscriptions from './endpoints/settings/webhookSubscriptions';
import connections from './endpoints/settings/connections';
import aiTasks from './endpoints/aiTasks';
import azureDevops from './endpoints/azureDevops';
import nudges from './endpoints/nudges';

const api = {
  ...account,
  ...profile,
  ...invitations,
  ...goals,
  ...keyResults,
  ...cycles,
  ...users,
  ...teams,
  ...labels,
  ...customGoalFilters,
  ...checkIns,
  ...teamMemberReports,
  ...search,
  ...settings,
  ...metrics,
  ...jira,
  ...recommendedActions,
  ...overTimeCharts,
  ...kpis,
  ...initiatives,
  ...currencies,
  ...goalTemplates,
  ...conversations,
  ...uploads,
  ...planner,
  ...businessUnits,
  ...notes,
  ...comments,
  ...qualityChecker,
  ...strategicElements,
  ...entityLinks,
  ...powerBi,
  ...excel,
  ...mcp,
  ...companionContexts,
  ...conversationStarters,
  ...nudgeSettings,
  ...webhookSubscriptions,
  ...connections,
  ...aiTasks,
  ...azureDevops,
  ...nudges,
};

export default api;
